<mat-sidenav-container class="client-container">
  <mat-sidenav
    style="width: 50%; overflow-x: hidden !important"
    #sidenav
    mode="over"
    class="main create-mail"
    position="end"
    [opened]="openAddExpiredListingsNoteSheetValue"
    disableClose
  >
    <form [formGroup]="ListingsOwnerForm">
      <div class="sliding-sheet-header">
        <h4 class="ml-4 pt-1">Expired Listings Owner Details</h4>
        <button type="button" (click)="closeAddContactSheet()"><mat-icon>close</mat-icon></button>
      </div>

      <div class="sliding-sheet-body">
        <div class="row">
          <div class="col-md-10 col-sm-12 col-12">
            Property Address
            <p class="w-100 mb-2">
              <b
                >{{ addContactSheetContext?.StdAddress?.UnparsedAddress }},{{
                  addContactSheetContext?.StdAddress?.City
                }},{{ addContactSheetContext?.StdAddress?.StateOrProvince }},{{
                  addContactSheetContext?.StdAddress?.PostalCode
                }}</b
              >
            </p>
          </div>
        </div>

        <div class="ownerDetails">
          <h6 class="client-head">Owner Details</h6>

          <div class="row">
            <div class="col-md-4 col-sm-4 col-12">
              <mat-form-field class="w-100 mb-3">
                <input
                  class="capitalize"
                  matInput
                  formControlName="currentOwnerName"
                  placeholder="Owner Name"
                  autocomplete="off"
                />
              </mat-form-field>
            </div>

            <div class="col-md-4 col-sm-4 col-12">
              <mat-form-field class="w-100 mb-3">
                <input matInput formControlName="currentOwnerEmail" placeholder="Owner Email" autocomplete="off" />
                <mat-error *ngIf="ListingsOwnerForm.get('currentOwnerEmail')?.hasError('email')">
                  Invalid email format
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-4 col-sm-4 col-12">
            <p>
              Listed On <br /><b>
                {{
                  addContactSheetContext?.ListingContractDate
                    ? (addContactSheetContext?.ListingContractDate | date: 'MM/dd/yy')
                    : '--'
                }}
              </b>
            </p>
          </div>
          <div class="col-md-4 col-sm-4 col-12">
            <p>
              Expired On <br /><b>
                {{ addContactSheetContext?.expiredOn ? addContactSheetContext?.expiredOn : '--' }}
              </b>
            </p>
          </div>
        </div>

        <div class="row">
          <div class="col-md-4 col-sm-4 col-12">
            <p>
              Days On Market <br /><b>
                {{ addContactSheetContext?.DaysOnMarket ? addContactSheetContext?.DaysOnMarket : '--' }}
              </b>
            </p>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12 col-sm-12 col-12">
            <h6>Notes</h6>
            <mat-form-field appearance="outline" class="w-100">
              <textarea
                formControlName="note"
                placeholder="Type your message..."
                class="responsive-textarea"
                rows="3"
                matInput
              ></textarea>
              <mat-error *ngIf="ListingsOwnerForm.get('note')?.hasError('minlength')">
                Note must be at least 15 characters
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="mb-3" style="float: left">
          <button
            class="my-2 save-contact mr-2"
            type="button"
            (click)="updateOwnerData()"
            [disabled]="ListingsOwnerForm.invalid"
            color="primary"
            mat-stroked-button
          >
            Save
          </button>
        </div>
        <div class="clearfix">&nbsp;</div>
      </div>
    </form>
  </mat-sidenav>
</mat-sidenav-container>
